import { render, staticRenderFns } from "./ChatNoticeCard.vue?vue&type=template&id=0aab6156"
import script from "./ChatNoticeCard.vue?vue&type=script&lang=js"
export * from "./ChatNoticeCard.vue?vue&type=script&lang=js"
import style0 from "./ChatNoticeCard.vue?vue&type=style&index=0&id=0aab6156&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports